import { render, staticRenderFns } from "./CardsRecovery.vue?vue&type=template&id=08aa3cda&scoped=true"
import script from "./CardsRecovery.vue?vue&type=script&lang=js"
export * from "./CardsRecovery.vue?vue&type=script&lang=js"
import style0 from "./CardsRecovery.vue?vue&type=style&index=0&id=08aa3cda&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08aa3cda",
  null
  
)

export default component.exports